import { shellOptions } from '../model/meControl.ts';

export function initializeMeControl() {
    // If msCommonShell already exists, load it.
    if (window.msCommonShell) {
        window.msCommonShell.load(shellOptions);
    }

    // If msCommonShell does not exist, create it and load it.
    else {
        // Load the meControl once msCommonShell is loaded.
        window.onShellReadyToLoad = function () {
            window.onShellReadyToLoad = null;
            window.msCommonShell.load(shellOptions);
        };
    };
};